import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiIntegration } from "../../_services/api.integration";
//import { LocalStorageService, SessionStorageService } from "angular-web-storage";
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { environment } from "../../../environments/environment";
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.css']
})
export class PaymentStatusComponent implements OnInit {
  pay: any = {};
  comments: string;
  refNum: string;
  externalRefNum: string;
  paymentMode: any = [];

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User) {
    this.g.page = "Payment Status";
    this.api.getInvoicesById(this.route.snapshot.params['id']).subscribe((data: any) => {
      this.pay = data;
    }, err => {
      this.alertService.error('Error', err);
    });
    this.api.getValues("1", "PAYMENT_TYPE", "PAYMENT_TYPE", "PAYMENT_TYPE").subscribe((data: any) => {
      this.paymentMode = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {
  }

  processingPayment() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updatePaymentStatus', {
      "invoiceHeaderId": this.route.snapshot.params['id'],
      "comments": this.comments,
      "accountOwnerId": this.user.accountOwnerId,
      "paymentStatus": "PAID",
      "paymentType": this.pay.paymentType,
      "paymentRefNumber": this.pay.paymentRefNumber
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Payment', 'Status Updated Successfully');
          this.router.navigate(['/admin/invoices']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  processingPaymentAdmin() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updatePaymentStatus', {
      "invoiceHeaderId": this.route.snapshot.params['id'],
      "comments": this.comments,
      "accountOwnerId": this.user.accountOwnerId,
      "paymentStatus": "PAID",
      "paymentType": this.pay.paymentType,
      "paymentRefNumber": this.pay.paymentRefNumber
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Payment', 'Status Updated Successfully');
          this.router.navigate(['/admin/adminInvoice']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
